import { PropsWithChildren, ReactNode } from 'react';

const ConditionalRender: React.FunctionComponent<PropsWithChildren<{
  visible: boolean;
  fallback?: ReactNode;
}>> = ({ children, visible, fallback = null }) => {
  if (!visible) return <>{fallback}</>;
  return <>{children}</>;
};

export default ConditionalRender;
